import React from 'react';

const CheckDeviceService =  {
    checkMobile:()=>{
        const mobile = (/iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase()));
        if (mobile) {
            return true
        }else{
            return false
        }
    },
    //이 페이지를 여는 앱은 모두 RN이라, react-native-webview가 만드는 window.ReactNativeWebView로 판별한다
    checkApp:()=>{
        return !!window.ReactNativeWebView
    },
    //앱에서만 아이디·비밀번호 입력란의 자동 첫 글자 대문자·자동 수정을 끈다
    noAutoCapitalizeProps:()=>{
        return CheckDeviceService.checkApp() ? {autoCapitalize:'none', autoCorrect:'off', spellCheck:false} : {}
    }
};

export default CheckDeviceService;